import Icon from '@/common/components/Icon';
import { NavigateLink } from '@/common/components/links/NavigateLink';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

const THead = styled.thead`
	th {
		background-color: #0cd891;
	}
`;

const TBody = styled.tbody`
	td {
		background-color: #d4ffed;
	}
`;

export const LoginNow = ({ data = [] }) => {
	return (
		<table className='styled-table'>
			<THead>
				<tr>
					<th colSpan={4}>Logged Users</th>
				</tr>
				<tr>
					<th>Id</th>
					<th>Username</th>
					<th>Logged at</th>
					<th>Actions</th>
				</tr>
			</THead>
			<TBody className='queue'>
				{data.length > 0 ? (
					data.map((element, i) => (
						<tr key={i}>
							<td>{i + 1}</td>
							<td>{element.username}</td>
							<td>{moment(element.login_at).format('DD/MM HH:mm:ss')}</td>
							<td>
								<NavigateLink
									target='_blank'
									to={`/settings/user/list?mode=show&userId=${element.consultant}`}
								>
									<Icon name='user' />
								</NavigateLink>
							</td>
						</tr>
					))
				) : (
					<tr>
						<td colSpan={6}>There is no users</td>
					</tr>
				)}
			</TBody>
		</table>
	);
};
